import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';
import moment from 'moment';
import { mainReducers } from './mainReducers';

export const initialState = {
  openModals: [],
  activeEmailId: null,
  activeEmailData: {},
  activeEmailModalTab: 'overview',
  activeView: 'operationsLog',
  isSearching: false,
  isAppLoading: true,
  isLoadingItems: false,
  isLoadingSingleEmailData: false,
  emailContentPreviewType: 'preview',
  emails: [],
  selectedEmails: {},
  filters: {
    dateRange: {
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
    emailToSearch: '',
    emailSearchToFromToggle: 'SearchFrom',
    emailStatus: '',
  },
  sorting: {
    sortBy: '',
    sortDirection: 'DESC',
  },
  pagination: {
    emails: {
      size: 10,
      skip: 0,
      totalItemCount: 0,
    },
  },
};

const rootReducer = mapActionToReducer({
  default: initialState,
  ...mainReducers,
});

export default reduceReducers(rootReducer);
